import { get } from 'lodash';
import { ContentFields } from '@broadleaf/admin-components/dist/cms/components';
import { useState } from 'react';

/**
 * Wrapper around the ContentFields component to check for ContentItems with a reference type of 'SORT_FIELD'.
 * If a sort field is found, change the reference lookup configurations in the metadata to support looking up sort fields.
 *
 * This replaces the 'PRODUCT' lookup data with the 'SORT_FIELD' lookup data. This is a workaround to support looking up
 * sort fields in the admin.
 *
 * @param props The properties passed to the component
 * @returns {JSX.Element} ContentFields component
 * @constructor
 */
const AuroraContentFields = props => {
  const [hasSortField, setHasSortField] = useState(false);

  const formikModelFields = get(props, 'formik.values.model.fields');
  if (formikModelFields) {
    for (const field of formikModelFields) {
      if ('SORT_FIELD' === get(field, 'referenceType')) {
        setHasSortField(true);
        field.referenceType = 'PRODUCT'; // this is a hack
      }
    }
  }

  if (hasSortField) {
    const attrs = get(props, 'metadata.attributes');
    const sortFieldConfig = get(attrs, 'sortField_lookup_config');
    if (sortFieldConfig) {
      attrs.product_lookup_config = sortFieldConfig;
    }
  }

  return <ContentFields {...props} />;
};

export { AuroraContentFields };
